export default __webpack_public_path__ + "static/media/left_trees.8ca84407.svg";